import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import type { Response } from "../interfaces";

export interface Image {
  image_id?: string;
  title: string;
  image_link: string;
  created_at?: string;
  updated_at?: string;
}

export const imageApi = createApi({
  reducerPath: "imageApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Image"],
  endpoints: (builder) => ({
    getImages: builder.query<Response<Image[]>, void>({
      query: () => ({
        url: "images",
        method: "GET",
      }),
      providesTags: ["Image"],
    }),
    getImage: builder.query<Response<Image>, string>({
      query: (id) => ({
        url: `images/${id}`,
        method: "GET",
      }),
      providesTags: ["Image"],
    }),
    uploadImage: builder.mutation<
      Response<Image>,
      FormData
    >({
      query: (formData) => ({
        url: "images/upload",
        method: "POST",
        data: formData,
      }),
      invalidatesTags: ["Image"],
    }),
    createImage: builder.mutation<Response<Image>, Partial<Image>>({
      query: (image) => ({
        url: "images",
        method: "POST",
        data: image,
      }),
      invalidatesTags: ["Image"],
    }),
    updateImage: builder.mutation<
      Response<Image>,
      { id: string; data: Partial<Image> }
    >({
      query: ({ id, data }) => ({
        url: `images/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["Image"],
    }),
    deleteImage: builder.mutation<Response<void>, string>({
      query: (id) => ({
        url: `images/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Image"],
    }),
  }),
});

export const {
  useGetImagesQuery,
  useGetImageQuery,
  useUploadImageMutation,
  useCreateImageMutation,
  useUpdateImageMutation,
  useDeleteImageMutation,
} = imageApi;

